import {
  PaymentCurrencyType,
  PaymentProviderType,
  PaymentStatusType,
  type PaymentsFilterInputType,
} from "@/types/graphql/partner.generated";
import {
  isEnumValue,
  toIdList,
  toIsoDate,
} from "@/partner/shared/utils/filterValues";

/**
 * Значения фильтра из querystring в аргумент `payments(filter:)`. Чистая
 * функция с проверками (см. `shared/utils/filterValues`): enum'ы сверяются со
 * сгенерированными типами, даты парсятся moment'ом, мусор молча выбрасывается.
 * Пустой результат отдаётся как `undefined`, а не `{}`: запрос без аргумента
 * ведёт себя как до появления фильтров.
 */
export function buildPaymentsFilter(
  filter: Record<string, unknown>
): PaymentsFilterInputType | undefined {
  const result: PaymentsFilterInputType = {};

  if (typeof filter.search === "string" && filter.search) {
    result.search = filter.search;
  }

  if (isEnumValue(PaymentStatusType, filter.status)) {
    result.status = filter.status;
  }

  if (isEnumValue(PaymentCurrencyType, filter.currency)) {
    result.currency = filter.currency;
  }

  const productIds = toIdList(filter.productIds);
  if (productIds) result.productIds = productIds;

  if (Array.isArray(filter.providers)) {
    const providers = filter.providers.filter(
      (provider): provider is PaymentProviderType =>
        isEnumValue(PaymentProviderType, provider)
    );
    if (providers.length > 0) result.providers = providers;
  }

  const dateFrom = toIsoDate(filter.dateFrom);
  if (dateFrom) result.dateFrom = dateFrom;

  const dateTo = toIsoDate(filter.dateTo);
  if (dateTo) result.dateTo = dateTo;

  return Object.keys(result).length > 0 ? result : undefined;
}
